import Grid from "./grid";
import {riskDashboard, RiskDashboard} from "./RiskDashboardComponent";
import {
    riskDashboardNotifications,
    RiskDashboardNotifications
} from "./notifications/RiskDashboardNotificationsComponent";
import {riskDashboardActions, RiskDashboardActions} from "./actions/RiskDashboardActionsComponent";

export default angular.module("tfApp.disk.dashboard", [Grid])
                      .component(RiskDashboard, riskDashboard())
                      .component(RiskDashboardNotifications, riskDashboardNotifications())
                      .component(RiskDashboardActions, riskDashboardActions())
                      .name;
